import React,{useState,useEffect,useRef} from 'react'
import { useRecoilState } from 'recoil';
import { accountInfo } from '../../../plugins/adminRecoil';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import axios from '../../../plugins/axios';
import Toast from "../../../plugins/useToast";

import {ReactComponent as IconArrowUp} from '../../../assets/icons/ic-arrow-up.svg'
import {ReactComponent as IconArrowDown} from '../../../assets/icons/ic-arrow-down.svg'
import {ReactComponent as IconCheck} from '../../../assets/icons/ic-check_blue.svg';

const UserSettings = ({userInfo, handleUserInfo}) => {
    const { t } = useTranslation()
    const isFirstRender = useRef(true);
    const [language, setLanguage] = useState('en')
    const [AccountInfo, setAccountInfo] = useState({});
    const [departmentList, setDepartmentList] = useState([]);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const langOptions = [
        { value: 'ko', label: '한국어' },
        { value: 'en', label: 'English' },
        { value: 'it', label: 'Italiano' },
        { value: 'pl', label: 'Polski' },
    ]

    // ✅ 사용자 정보 저장
    const handleSaveUser = async () => {
        try{        
            const user_payload = {                
                name: AccountInfo.Name,
                phoneNumber: AccountInfo.Phone,
                departmentId: AccountInfo.Department.value,
                loginId: AccountInfo.ID,
                note: AccountInfo.Note,
                role: AccountInfo.Type,
                status: AccountInfo.status,
            }

            const resUser = await axios.put(`/user/${AccountInfo.userId}`, user_payload); // API 경로는 실제 API에 맞게 수정
            if(resUser.code != 200) throw resUser;

            const language_payload = {                
                language : language,
            }

            const resLang = await axios.patch(`/user/me/language`, language_payload);
            if(resLang.code != 200) throw resLang;

            Toast({ isSuccess: true, msg: t(`admin.myAccount.saveSuccess`) });
            handleUserInfo();
        }
        catch(err) {
            console.error("Error saving data:", err);
        }
    }    

    // ✅ Department 선택을 위한 리스트 가져오기 함수
    const getDepartment = async () => {
        try{
            const res = await axios.get('/departments');
            if(res.code != 200) throw res;            
            
            const department = [];
            department.push({value : null, label : t('admin.myAccount.Unassigned')});

            const departments = res.data.content.map(department => ({
                value: department.id,
                label: department.name
            }));
            department.push(...departments);

            setDepartmentList(department);
        }
        catch(err) {
            console.warn(err);
        }
    }

    // ✅ 컴포넌트가 처음 렌더링될 때 사용자 정보 가져오기
    useEffect(() => {
        // if (isFirstRender.current) {
        //     isFirstRender.current = false;
        //     return;
        // }

        if(userInfo){            
            setLanguage(userInfo.language || 'en'); 

            // Title이랑 맵핑하기 위해 재구성
            setAccountInfo({
                userId : userInfo.id,
                Name : userInfo.name,
                ID : userInfo.loginId,
                Phone : userInfo.phoneNumber,
                Type : userInfo.role,
                Department : {value : userInfo.departmentId, label : userInfo.departmentName ? userInfo.departmentName : t('admin.myAccount.Unassigned')},
                Note : userInfo.note,
                status: userInfo.status,
                CreateAt : userInfo.createdAt,
                LastLogin : userInfo.lastLogin ? userInfo.lastLogin : null,
            }); 
        }
    }, [userInfo])
    

    useEffect(() => {        
        getDepartment();

        const handleClickOutside = (event) => {
            if (!event.target.closest('.select-dropdown')) {
                setIsDropdownOpen(null);
            }
        };
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [])

    return (
        <div className="">
            <div className="flex mb-10">
                <div className="">
                    <div className="admin-title">{t('admin.Preferences.Title')}</div>                    
                </div>
                <div className="admin-normal-btn save ml-auto w-[100px] text-white" onClick={() => { handleSaveUser() }}>{t('admin.Preferences.Save')}</div>
            </div>
            <div className="flex gap-10">     
                <div className="">
                    <div className="font-light text-[#E1E4E5] mb-3">{t('admin.profileInfo')}</div>
                        <div className="bg-[#323238] p-5 rounded-lg flex flex-col text-white">                        
                            <div className='flex flex-col gap-[12px]'>
                                <div className='flex justify-start items-center gap-[20px]'>
                                    <div className='w-[180px]'>
                                        <span className='text-white'>{t('admin.myAccount.Name')}</span><span className='text-[#FF2B5E]'>＊</span>
                                    </div>
                                    <div className='w-[376px]'>
                                        <input
                                            type="text"
                                            value={AccountInfo.Name || ''}
                                            onChange={(e) => {
                                                const value = e.target.value.replace(/[^\p{Script=Hangul}a-zA-Z0-9\s]/gu, ''); // 영문, 한글(완성+조합), 공백 허용
                                                setAccountInfo({ ...AccountInfo, Name: value });
                                            }}
                                            placeholder={t('admin.myAccount.NamePlaceholder')}
                                            className="admin-input w-full px-[12px] py-[7px]"    
                                            maxLength={30}                        
                                        />
                                    </div>
                                </div>
                                <div className='flex justify-start items-center gap-[20px]'>
                                    <div className='w-[180px]'>
                                        <span className='text-white'>{t('admin.myAccount.ID')}</span><span className='text-[#FF2B5E]'>＊</span>
                                    </div>
                                    <div className='w-[376px]'>
                                        <input
                                            type="text"
                                            value={AccountInfo.ID || ''}
                                            onChange={(e) => {
                                                // 이메일 형식에 허용되는 문자만 입력 가능
                                                const value = e.target.value.replace(/[^a-zA-Z0-9@._-]/g, '');
                                                setAccountInfo({ ...AccountInfo, ID: value });
                                            }}
                                            onBlur={                                
                                                (e) => {
                                                    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;    
                                                    if(e.target.value && !emailRegex.test(e.target.value)){
                                                        Toast({ isSuccess: false, msg: t('admin.myAccount.IDValid') });
                                                        setAccountInfo({ ...AccountInfo, ID: '' });
                                                    }
                                                }
                                            }
                                            placeholder={t('admin.myAccount.IDPlaceholder')}
                                            className="admin-input w-full px-[12px] py-[7px]"
                                            maxLength={50}
                                        />
                                    </div>
                                </div>                
                                <div className='flex justify-start items-center gap-[20px]'>
                                    <div className='w-[180px]'>
                                        <span className='text-white'>{t('admin.myAccount.Phone')}</span><span className='text-[#FF2B5E]'>＊</span>
                                    </div>
                                    <div className='w-[376px] flex justify-start items-center gap-[8px] '>
                                        <input
                                            type="text"
                                            value={AccountInfo.Phone || ''}
                                            onChange={(e) => {
                                                const value = e.target.value.replace(/[^0-9+-]/g, ''); // 숫자, +, - 만 허용
                                                setAccountInfo({ ...AccountInfo, Phone: value });
                                            }}
                                            className="admin-input w-full px-[12px] py-[7px]"
                                            maxLength={20}
                                        />                                           
                                    </div>
                                </div>
                                <div className='flex justify-start items-center gap-[20px]'>
                                    <div className='w-[180px]'>
                                        <span className='text-white'>{t('admin.myAccount.Type')}</span><span className='text-[#FF2B5E]'>＊</span>
                                    </div>
                                    <div className="flex items-center">
                                        <label className="custom-radio">
                                            <input
                                                type="radio"
                                                checked={AccountInfo.Type == 'USER'}
                                                onChange={() => setAccountInfo({ ...AccountInfo, Type: 'USER' })}
                                            />
                                            <span className="font-light">{t('admin.myAccount.TypeUser')}</span>
                                        </label>
                                        <label className="custom-radio">
                                            <input
                                                type="radio"
                                                checked={AccountInfo.Type == 'ADMIN'}
                                                onChange={() => setAccountInfo({ ...AccountInfo, Type: 'ADMIN' })}
                                            />
                                            <span className="font-light">{t('admin.myAccount.TypeAdmin')}</span>
                                        </label>
                                    </div>
                                </div>
                                <div className='flex justify-start items-center gap-[20px]'>
                                    <div className='w-[180px]'>
                                        <span className='text-white'>{t('admin.myAccount.Department')}</span>
                                    </div> 
                                    <div className="relative w-[376px] select-dropdown">
                                        <div className="border border-[#0D0D0F] bg-gradient-to-b from-[#5B5C60] to-[#303237] shadow-[inset_0_-2px_1px_0_rgba(255,255,255,0.10),inset_0_2px_0_0_rgba(255,255,255,0.12)] text-[#DEDEDE] w-full h-[32px] px-[8px] rounded-[6px] cursor-pointer flex items-center justify-between "
                                        onClick={(e) => { e.stopPropagation(); setIsDropdownOpen(!isDropdownOpen);}}>
                                            <div className="w-full whitespace-nowrap">{AccountInfo?.Department?.label}</div>
                                            <div className="pointer-events-none">
                                                {isDropdownOpen ? <IconArrowUp /> : <IconArrowDown />}
                                            </div>
                                        </div>
                                        {isDropdownOpen && (
                                            <div className="absolute top-[35px] bg-[#1F1F1F] w-full py-[8px] rounded-[6px] border border-[#5E5E5E] shadow-[0px_12px_12px_0px_rgba(0,0,0,0.4)] z-20">
                                                {
                                                    departmentList.map((department, index) => {
                                                        return (
                                                            <div key={index} className={`bg-[#1F1F1F] cursor-pointer h-[32px] flex items-center justify-between px-[8px] hover:bg-[#2F2F2F] 
                                                                ${AccountInfo?.Department?.value == department.value ? "text-[#3182F7]" : "text-white"}`}
                                                                onClick={(e) => { e.stopPropagation(); setAccountInfo({ ...AccountInfo, Department: department }); setIsDropdownOpen(false); }}>
                                                                {department.label}
                                                                {AccountInfo.Department.value == department.value && (
                                                                    <IconCheck className="w-4 h-4 ml-2" />
                                                                )}
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className='flex justify-start items-center gap-[20px]'>
                                    <div className='w-[180px]'>
                                        <span className='text-white'>{t('admin.myAccount.Note')}</span>
                                    </div>
                                    <div className='w-[376px]'>
                                        <textarea 
                                            className='w-full h-[120px] p-[7px_12px] rounded-[6px] bg-[#0D0D0F] shadow-[inset_0_-1px_0_0_#5A5C63,inset_0_2px_1px_0_rgba(0,0,0,0.50)] text-white border-none outline-none resize-none focus:outline-none focus:border-none'
                                            value={AccountInfo.Note || ''}
                                            onChange={(e) => setAccountInfo({ ...AccountInfo, Note: e.target.value })}
                                        >
                                        </textarea>
                                    </div>
                                </div>
                                <div className='flex justify-start items-center gap-[20px]'>
                                <div className='w-[180px]'>
                                    <span className='text-white'>{t('admin.myAccount.DateCreated')}</span>
                                </div>
                                <div className='w-[376px]'>
                                    {/* <p className='text-white'>{moment().format('YYYY-MM-DD hh:mm:ss')}</p> */}
                                    <p className='text-white'>{AccountInfo.CreateAt ? moment(AccountInfo.CreateAt).format('YYYY-MM-DD hh:mm:ss') : '-'}</p>
                                </div>
                            </div>
                            <div className='flex justify-start items-center gap-[20px]'>
                                <div className='w-[180px]'><span className='text-white'>{t('admin.myAccount.LastLogin')}</span></div>
                                <div className='w-[376px]'>
                                    <p className='text-white'>{AccountInfo.LastLogin ? moment(AccountInfo.LastLogin).format('YYYY-MM-DD hh:mm:ss') : '-'}</p>
                                </div>
                            </div>
                            <div className='flex justify-start items-center gap-[20px]'>
                                <div className='w-[180px]'>
                                    <span className='text-white'>{t('admin.myAccount.Status')}</span>
                                </div>
                                <div className="flex">
                                    <label className="custom-radio">
                                        <input
                                            type="radio"
                                            checked={AccountInfo.status === 'ACTIVE'}
                                            onChange={() => setAccountInfo({ ...AccountInfo, status: 'ACTIVE' })}
                                        />
                                        <span className="font-light">{t('admin.myAccount.StatusActive')}</span>
                                    </label>
                                    <label className="custom-radio">
                                        <input
                                            type="radio"
                                            checked={AccountInfo.status === 'INACTIVE'}
                                            onChange={() => setAccountInfo({ ...AccountInfo, status: 'INACTIVE' })}
                                        />
                                        <span className="font-light">{t('admin.myAccount.StatusInActive')}</span>
                                    </label>
                                </div>
                            </div>
                         </div>
                    </div>
                </div>
                <div className="" style={{ border: '1px solid var(--Cool-Neutral-Gray_14, #202024)', boxShadow: '-1px 0px 0px 0px #00000066' }} />
                <div className="">
                    <div className="font-light text-[#E1E4E5] mb-3">{t('admin.Preferences.Title')}</div>
                    <div className="bg-[#323238] p-5 rounded-lg w-[240px] h-[212px] flex flex-col text-white">
                        <div className="text-[#CBCED1] mb-5" style={{ fontSize: 18 }}>{t('admin.Preferences.Language')}</div>
                        {
                            langOptions.map((option) => (
                                <label key={`lang-option-${option.value}`} className="custom-radio mb-3">
                                    <input
                                        type="radio"
                                        checked={language === option.value}
                                        onChange={() => setLanguage(option.value)}
                                    />
                                    <span className="font-light" style={{ paddingLeft: 32, fontSize: 16 }}>{option.label}</span>
                                </label>
                            ))
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}

export default UserSettings